<template>
  <div class="mk">

    <!-- ════════════════════ DASHBOARD HEADER ════════════════════ -->
    <div class="mk-dash-header">
      <div class="mk-dash-header-top">
        <div>
          <div class="mk-eyebrow">MARKETING · SALES ANALYTICS</div>
          <h1 class="mk-title">Marketing</h1>
        </div>
        <div class="mk-header-actions">
          <div class="mk-stat-pill">
            <i class="fa-solid fa-calendar"></i>
            <strong>{{ anyoSelect }}</strong>
            <span>· {{ Number(totalNetoAnyo).toLocaleString('es', optionsNumber) }} €</span>
          </div>
          <div class="mk-stat-pill mk-stat-pill--vs" v-if="anyoVS">
            <i class="fa-solid fa-arrow-right-arrow-left"></i>
            <strong>{{ anyoVS }}</strong>
            <span>· {{ Number(totalNetoVs).toLocaleString('es', optionsNumber) }} €</span>
          </div>
          <div class="mk-stat-pill mk-stat-pill--sel" v-if="selected.length > 0">
            <i class="fa-solid fa-check"></i>
            <strong>{{ selected.length }}</strong>
            <span>seleccionados</span>
          </div>
        </div>
      </div>
    </div>

    <grafica-marketing :items="selected" :anyo="anyoSelect" :urls="productsUrl"></grafica-marketing>

    <!-- ════════════════════ FILTROS ════════════════════ -->
    <section class="mk-card">
      <header class="mk-card-head">
        <div class="mk-card-title">
          <span class="mk-chevron">›</span>
          <span>Filtros</span>
        </div>
      </header>
      <div class="mk-card-body">
        <div class="mk-filters">
          <div class="mk-filter">
            <label class="mk-filter-label">Año</label>
            <v-select
              v-model="anyoSelect"
              label="nombre"
              :options="anyos"
              :clearable="false"
              class="mk-vselect"
            />
          </div>
          <div class="mk-filter">
            <label class="mk-filter-label">Comparar con</label>
            <v-select
              v-model="anyoVS"
              label="nombre"
              :options="anyos"
              class="mk-vselect"
              placeholder="—"
            />
          </div>
        </div>

        <!-- Meses -->
        <div class="mk-meses">
          <div class="mk-meses-label">
            <span>Meses</span>
            <b-form-checkbox
              v-model="mesesTodosCheck"
              name="check-button"
              switch
              inline
              class="mk-meses-toggle"
            >
              Todos
            </b-form-checkbox>
          </div>
          <div class="mk-meses-grid">
            <button
              v-for="(item, index) in meses"
              :key="'mes-'+index"
              type="button"
              class="mk-mes"
              :class="{ 'is-active': item.active }"
              @click="item.active = !item.active"
            >
              {{ item.nombre }}
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- ════════════════════ PRODUCTOS ════════════════════ -->
    <section class="mk-card mk-card--table">
      <header class="mk-card-head">
        <div class="mk-card-title">
          <span class="mk-chevron">›</span>
          <span>Productos</span>
          <span v-if="selected.length > 0" class="mk-title-badge">{{ selected.length }} sel</span>
        </div>
        <div class="mk-card-actions">
          <button class="mk-quick-btn" @click="clearSelected">
            <i class="fa-solid fa-xmark"></i>
            <span>Limpiar</span>
          </button>
          <div class="mk-tops">
            <button
              v-for="n in [5, 10, 15, 20]"
              :key="'top-'+n"
              type="button"
              class="mk-top-btn"
              @click="selectTop(n)"
            >
              Top {{ n }}
            </button>
          </div>
        </div>
      </header>
      <div class="mk-search-bar">
        <i class="fa-solid fa-magnifying-glass"></i>
        <input
          type="text"
          placeholder="Buscar producto..."
          v-model="buscar"
        />
        <button v-if="buscar" class="mk-search-clear" @click="buscar = ''">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>

      <b-table
        :items="articulosBusqueda"
        :fields="columnasTable"
        class="mb-0 tabla-marketing"
        no-border-collapse
        sort-icon-left
        @sort-changed="sortChanged"
        ref="tableproducts"
        :busy="isBusy"
        :tbody-transition-props="transProps"
        id="table-products"
        @row-selected="onRowSelected"
        :fixed="true"
        small
        thead-class="text-uppercase text-muted"
      >
        <template #cell(check)="data">
          <b-form-checkbox
            :id="'checkbox-'+data.item.shopify_product_id"
            v-model="data.item.check"
            @change="checkClick(data.item)"
          />
        </template>

        <template #cell(show_details)="row">
          <span @click="row.toggleDetails" class="cursor-pointer">
            <i v-if="row.detailsShowing" class="fa-solid fa-chevron-up text-muted"></i>
            <i v-else class="fa-solid fa-chevron-down text-muted"></i>
          </span>
        </template>

        <template #row-details="row">
          <b-table
            :items="row.item.variantes"
            :fields="columnasTable"
            class="table table-borderless table-details"
            no-border-collapse
            sort-icon-left
            thead-class="hidden_header"
            small
          >
            <template #cell(title)="data">
              <span class="sku-button text-muted">{{ data.item.title.toLowerCase() }}</span>
            </template>

            <template #cell(devoluciones)="data">
              <span>{{ Number(data.item.devoluciones).toLocaleString('es', optionsNumber) }}</span>
            </template>

            <template #cell(descuentos)="data">
              <span>{{ Number(data.item.descuentos).toLocaleString('es', optionsNumber) }}</span>
            </template>

            <template #cell(total)="data">
              <span>{{ Number(data.item.total).toLocaleString('es', optionsNumber) }}</span>
            </template>

            <template #cell(vscantidad)="data">
              <span>{{ data.item.vsCantidad }}</span>
            </template>

            <template #cell(vstotal)="data">
              <span>{{ Number(data.item.vsTotal).toLocaleString('es', optionsNumber) }}</span>
            </template>

            <template #cell(vscantidaddif)="data">
              <span>{{ data.item.vsCantidadDif }}</span>
            </template>

            <template #cell(vstotaldif)="data">
              <span>{{ Number(data.item.vsTotalDif).toLocaleString('es', optionsNumber) }}</span>
            </template>
          </b-table>
        </template>

        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner variant="primary" class="align-middle"></b-spinner>
            <strong class="ml-50 text-muted">Cargando...</strong>
          </div>
        </template>

        <template #cell(sku)="data">
          <span class="sku-button" @click="rowClick(data.item)">{{ data.item.sku.toLowerCase() }}</span>
        </template>

        <template #cell(devoluciones)="data">
          <span>{{ Number(data.item.devoluciones).toLocaleString('es', optionsNumber) }}</span>
        </template>

        <template #cell(descuentos)="data">
          <span>{{ Number(data.item.descuentos).toLocaleString('es', optionsNumber) }}</span>
        </template>

        <template #cell(total)="data">
          <span>{{ Number(data.item.total).toLocaleString('es', optionsNumber) }}</span>
        </template>

        <template #cell(vscantidad)="data">
          <span>{{ data.item.vsCantidad }}</span>
        </template>

        <template #cell(vstotal)="data">
          <span>{{ Number(data.item.vsTotal).toLocaleString('es', optionsNumber) }}</span>
        </template>

        <template #cell(vscantidaddif)="data">
          <span>{{ data.item.vsCantidadDif }}</span>
        </template>

        <template #cell(vstotaldif)="data">
          <span>{{ Number(data.item.vsTotalDif).toLocaleString('es', optionsNumber) }}</span>
        </template>
      </b-table>

      <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10"></div>
    </section>

    <!-- Modal analytics -->
    <b-modal
      id="modal-analityc"
      :title="itemSelect.sku"
      centered
      size="xl"
      hide-footer
    >
      <h5 class="mb-1">Ventas por mes</h5>
      <b-row>
        <b-col cols="9">
          <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
        </b-col>
        <b-col cols="3">
          <apexchart type="radar" height="350" :options="chartOptionsRadar" :series="series"></apexchart>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import axios from '@axios'
import { BTable, BFormCheckbox, BFormInput, BFormGroup, BModal, BCardBody, BCard, BBadge, BRow, BCol, BSpinner, BButton } from 'bootstrap-vue'
import vSelect from 'vue-select'
import GraficaMarketing from '../layouts/components/marketing/graficas.vue'

  export default {
    components: {
        BFormCheckbox,
        BTable,
        BFormInput,
        BFormGroup,
        BCardBody,
        BCard,
        BBadge,
        BRow,
        BCol,
        vSelect,
        BSpinner,
        BButton,
        GraficaMarketing
    },
    data () {
      return {
        status: false,
        mesesTodosCheck: true,
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        isBusy: true,
        optionsNumber: { 
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        },//show_details
        columnasAll: [
          {
          key: "check",
          label: "",
          sortable: false,
          thStyle: { width: "1%" },

        },
        {
          key: "show_details",
          label: "",
          sortable: false,
          thStyle: { width: "1%" },

        },
        {
          key: "title",
          label: "Title",
          sortable: true,
          thStyle: { width: "15%" },
        },
        {
          key: "ratio",
          label: "Ratio",
          sortable: true,
          thStyle: { width: "5%" },
        },
        {
          key: "stock",
          label: "Stock",
          sortable: true,
          thStyle: { width: "5%" },
        },
        {
          key: "cantidad",
          label: "QTY",
          sortable: true,
          thStyle: { width: "5%" },
        },
        {
          key: "devoluciones",
          label: "Returns",
          sortable: true,
          thStyle: { width: "5%" },
        },
        {
          key: "descuentos",
          label: "Discount",
          sortable: true,
          thStyle: { width: "5%" },
        },
        {
          key: "total",
          label: "Total",
          sortable: true,
          thStyle: { width: "5%" },
        }],
        columnasTable: [],
        articulos: [],
        articulosBusqueda: [],
        variantsDetails: [],
        variantes: [],
        anyoSelect: new Date().getFullYear(),
        anyoVS: null,
        meses: [
          {nombre: "Enero", value: 1, active: true},
          {nombre: "Febrero", value: 2, active: true},
          {nombre: "Marzo", value: 3, active: true},
          {nombre: "Abril", value: 4, active: true},
          {nombre: "Mayo", value: 5, active: true},
          {nombre: "Junio", value: 6, active: true},
          {nombre: "Julio", value: 7, active: true},
          {nombre: "Agosto", value: 8, active: true},
          {nombre: "Septiembre", value: 9, active: true},
          {nombre: "Octubre", value: 10, active: true},
          {nombre: "Noviembre", value: 11, active: true},
          {nombre: "Diciembre", value: 12, active: true}
          ],
        anyosJson: Array.from({ length: new Date().getFullYear() - 2019 + 1 }, (_, i) => {
          const y = new Date().getFullYear() - i;
          return { nombre: String(y), value: y, active: true };
        }),
        anyos: Array.from({ length: new Date().getFullYear() - 2019 + 1 }, (_, i) => new Date().getFullYear() - i),
        buscar: "",
        countItemView: 30,
        nextScrollItemView: 20,
        defaultItemView: 30,
        itemSelect: {pedido: undefined},
        watching: true,
        lastSort: null,
        series: [{
              name: "Desktops",
              data: [10, 41, 35, 51, 49, 62, 69, 91, 148]
          }],
        chartOptions: {
            chart: {
              height: 350,
              type: 'line',
              zoom: {
                enabled: false
              },
              toolbar: {
                show: false,
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'straight'
            },
            title: {
              text: '',
              align: 'left'
            },
            grid: {
              row: {
                colors: ['transparent', 'transparent'],
                opacity: 0.5
              },
            },
            xaxis: {
              categories: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            }
          },
          chartOptionsRadar: {
             chart: {
              height: 350,
              type: 'radar',
              zoom: {
                enabled: false
              },
              toolbar: {
                show: false,
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'straight'
            },
            title: {
              text: '',
              align: 'left'
            },
            grid: {
              row: {
                colors: ['transparent', 'transparent'],
                opacity: 0.5
              },
            },
            xaxis: {
              categories: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            }
          },
        totalNetoAnyo: 0,
        totalNetoVs: 0,
        selected: [],
        productsUrl: []
      }
    },

    methods:{
      loadItems(){

        this.cargarColumnas();

        axios.post("/uso", {seccion:"marketing"});

        axios
          .get("/ventas/mensual")
          .then(response => {
              return response.data;
          })
          .then(res => {
            
             axios
              .get("/articulos/variants")
              .then(response => {
                  return response.data;
              })
              .then(resVariantes=> {          
                
                this.variantes = resVariantes.map((x) => {
                  return {
                    ...x,
                    title: x.sku,
                    cantidades: [],
                    cantidad: 0,
                    devoluciones: 0,
                    descuentos: 0,
                    total: 0,
                    vsCantidad: 0,
                    vsTotal: 0,
                    vsCantidadDif: 0,
                    vsTotalDif: 0,
                    ratio: 0
                  };
                });

                //console.log(res);

                res.forEach(element => {
                  this.addCantidadAnyos(element);
                });                                

                this.variantes.forEach(variante => {
                    this.anyos.forEach(element => {
                      this.getCantidadAnyo(variante,element.value)
                    });
                });

                axios
                .get("/articulos/products")
                .then(response => {
                    return response.data;
                })
                .then(resProducts=> {

                  this.articulos = resProducts.map((x) => {
                    return {
                      ...x,
                      cantidad: 0,
                      devoluciones: 0,
                      descuentos: 0,
                      total: 0,
                      stock: 0,
                      vsCantidad: 0,
                      vsTotal: 0,
                      vsCantidadDif: 0,
                      vsTotalDif: 0,
                      ratio: 0,
                      variantes: this.agregarVariantesAlProductos(x),
                      check: false
                    };
                  });
                  
                  this.articulos.forEach(articulo => {
                    this.calcularDatos(articulo)
                  });

                  this.articulosBusqueda = this.articulos.slice(0,this.countItemView);

                  this.isBusy = false;

                  //PRUEBAS
                  /*let indexPruebas = this.articulos.findIndex(x => x.title == "Leather Desk Mat")
                  this.articulos[indexPruebas].variantes = [this.articulos[indexPruebas].variantes[1],this.articulos[indexPruebas].variantes[2]]
                  this.selected.push(this.articulos[indexPruebas]);
                  this.articulos[indexPruebas].check = true;*/
                  //FIN PRUEBAS

                });

              });

          });

          axios
            .get("/visitas/urls")
            .then(response => {
                return response.data;
            })
            .then(res => {
              this.productsUrl = res;
            });
      },
      calcularDatos(articulo)
      {      
        articulo.stock = 0;
        articulo.cantidad = 0;
        articulo.devoluciones = 0;
        articulo.descuentos = 0;
        articulo.total = 0;

        let vsCantidad = 0;
        let vsTotal = 0;

        articulo.variantes.forEach(variante => {
          let vsCantidadVariante = 0;
          let vsTotalVariante = 0;
          variante.cantidad = 0;
          variante.devoluciones = 0;
          variante.descuentos = 0;
          variante.total = 0;

          articulo.stock += variante.stock;
          variante.cantidades.forEach(cantidad => {
            this.meses.forEach(mes => {

              if(mes.active)
              {
                  if(cantidad.anyo == this.anyoSelect && cantidad.mes == mes.value)
                  {
                    articulo.cantidad += cantidad.cantidad;
                    articulo.devoluciones += cantidad.devoluciones;
                    articulo.descuentos += cantidad.descuentos;
                    articulo.total += cantidad.total;

                    variante.cantidad += cantidad.cantidad;
                    variante.devoluciones += cantidad.devoluciones;
                    variante.descuentos += cantidad.descuentos;
                    variante.total += cantidad.total;
                  }
                  else
                  {
                    if(cantidad.anyo == this.anyoVS && cantidad.mes == mes.value)
                    {
                      vsCantidad += cantidad.cantidad;
                      vsTotal += cantidad.total;

                      vsCantidadVariante += cantidad.cantidad;
                      vsTotalVariante += cantidad.total;
                    }
                  }
              }
              
            });

            variante.vsTotalDif = variante.total - vsTotalVariante;
            variante.vsCantidadDif = variante.cantidad - vsCantidadVariante;

            variante.vsCantidad = vsCantidadVariante;
            variante.vsTotal = vsTotalVariante;

          });
        });

        articulo.vsTotalDif = articulo.total - vsTotal;
        articulo.vsCantidadDif = articulo.cantidad - vsCantidad;
        articulo.vsTotal = vsTotal;
        articulo.vsCantidad = vsCantidad;

        this.totalNetoAnyo += articulo.total;
        this.totalNetoVs += vsTotal;

        /*articulo.devoluciones = Math.round((articulo.devoluciones) * 100) / 100;
        articulo.descuentos = Math.round((articulo.descuentos) * 100) / 100;
        articulo.total = Math.round((articulo.total) * 100) / 100;*/

        /*articulo.devoluciones = Number(articulo.devoluciones).toLocaleString('es', options);
        articulo.descuentos = Number(articulo.descuentos).toLocaleString('es', options);
        articulo.total = Number(articulo.total).toLocaleString('es', options);*/

      },
      agregarVariantesAlProductos(producto)
      {
        let auxVariantes = this.variantes.filter(function (el) {
          return el.shopify_product_id == producto.shopify_product_id;
        });

        return auxVariantes;
      },
      cargarColumnas()
      {

        this.columnasTable = [];

        this.columnasAll.forEach(column => {
          this.columnasTable.push(column);
        });

        if(this.anyoVS != null && this.anyoSelect != this.anyoVS)
        {
          this.columnasTable.push( 
          {
            key: "vsRatio",
            label: "QTY_" + this.anyoVS,
            sortable: true,
            thStyle: { width: "5%" },
          },        
          {
            key: "vsCantidad",
            label: "QTY_" + this.anyoVS,
            sortable: true,
            thStyle: { width: "5%" },
          },        
          {
            key: "vsCantidaddif",
            label: "QTY_DIF_" + this.anyoVS,
            sortable: true,
            thStyle: { width: "5%" },
          },
          {
            key: "vsTotal",
            label: "TT_" + this.anyoVS,
            sortable: true,
            thStyle: { width: "5%" },
          },          
          {
            key: "vsTotaldif",
            label: "TT_DIF_" + this.anyoVS,
            sortable: true,
            thStyle: { width: "5%" },
          }
          );

        }

        /*,
        {
          key: "vsCantidad",
          label: "vs Cantidad",
          sortable: true,
        },
        {
          key: "vsTotal",
          label: "vs Total",
          sortable: true,
        }*/

        //console.log(this.columnasTable);
      },
      addCantidadAnyos(dato)
      {

        let auxVariante = this.variantes.filter(function (el) {
          return el.sku == dato.sku;
        });

        if(auxVariante.length > 0)
        {

          let mesAnyoData = auxVariante[0].cantidades.filter(function (el) {
            return el.anyo == dato.anyo && el.mes == dato.mes;
          });

          if(dato.total_ventas != 0)
          {
            if(mesAnyoData.length > 0)
            {
              mesAnyoData[0].cantidad += dato.cantidad;
              mesAnyoData[0].devoluciones += dato.devoluciones;
              mesAnyoData[0].descuentos += dato.descuentos;
              mesAnyoData[0].total += dato.total_ventas;
            }
            else
            {
              auxVariante[0].cantidades.push({
                anyo: dato.anyo, 
                mes: dato.mes, 
                cantidad: dato.cantidad,
                devoluciones: dato.devoluciones,
                descuentos: dato.descuentos,
                total: dato.total_ventas
                });
            }
          }
          
        }

      },
      getCantidadAnyo(item, anyo)
      {

        let total = 0;

        let tieneValor = false;

        this.meses.forEach(mes => {

          if(mes.active)
          {

            let cantidad = item.cantidades.filter(function (el) {
              return el.anyo == anyo && el.mes == mes.value;
            });

            if(cantidad.length > 0)
            {
              total += cantidad[0].total
              tieneValor = true;
            }

          }
          
        });

        if(total == 0 && !tieneValor)
          total = "";

        item[anyo] = total;

        return total;

      },
      calcularPrevisiones(item)
      {

         let total = 0;

        let auxAnyos = JSON.parse(JSON.stringify(this.anyos));

        if(auxAnyos[0].value == new Date().getFullYear())
        {
            let valido = true;

            let mesActual = new Date().getMonth()+1;
            this.meses.forEach(mes => {
                if(mes.active && mes.value >= mesActual)
                    valido = false;
            });

            if(!valido)
                auxAnyos.shift();
        }

        auxAnyos = auxAnyos.filter(function( obj ) {
            return obj.active == true;
        });

        auxAnyos.forEach(anyo => {
            if(anyo.active)
            {
                anyo.total = 0;

                this.meses.forEach(mes => {
                    if(mes.active)
                    {
                        let cantidad = item.cantidades.filter(function (el) {
                            return el.anyo == anyo.value && el.mes == mes.value;
                        });

                        if(cantidad.length > 0)
                        {
                            anyo.total += cantidad[0].total
                        }
                    }
                });
            }
        });

        let startCount = false;

        let cantidadAnyos = 0;
        let porcentajeAnyos = 0;

        let ultimoValorValido = 0;

        for (let y = auxAnyos.length-1; y >= 0; y--) {
            if(auxAnyos[y].active && (auxAnyos[y].total > 0 || startCount) )
            {
                cantidadAnyos++;
                startCount = true;
                if(y > 0)
                {
                    let aux = auxAnyos[y-1].total-auxAnyos[y].total;
                    porcentajeAnyos += aux;   
                }

                ultimoValorValido = auxAnyos[y].total;
            }
        }


        total = porcentajeAnyos / cantidadAnyos;

        if(total > 0)
        {
            total = ultimoValorValido + total;
        }
        else
        {
            total = ultimoValorValido - total;
        }

        if(isNaN(total))
            total = "";
        else
            total = Math.round(total);

        item.prevision = total;
        item.stockIdeal = total - item.stock;

        if(item.stockIdeal <= 0)
            item.stockIdeal = "";
      },
      getFuturoPorcentaje(item)
      {
        let total = 0;

        let auxAnyos = JSON.parse(JSON.stringify(this.anyos));

        if(auxAnyos[0].value == new Date().getFullYear())
            auxAnyos.shift();
        
        auxAnyos.forEach(anyo => {
            if(anyo.active)
            {
                anyo.total = 0;

                this.meses.forEach(mes => {
                    if(mes.active)
                    {
                        let cantidad = item.cantidades.filter(function (el) {
                            return el.anyo == anyo.value && el.mes == mes.value;
                        });

                        if(cantidad.length > 0)
                        {
                            anyo.total += cantidad[0].total
                        }
                    }
                });
            }
        });

        let startCount = false;

        let cantidadAnyos = 0;
        let porcentajeAnyos = 0;

        let ultimoValorValido = 0;

        for (let y = auxAnyos.length-1; y >= 0; y--) {
            if(auxAnyos[y].active && (auxAnyos[y].total > 0 || startCount) )
            {
                cantidadAnyos++;
                startCount = true;
                if(y > 0)
                {
                    let aux = ((auxAnyos[y-1].total-auxAnyos[y].total)/auxAnyos[y].total)*100;
                    porcentajeAnyos += aux;   
                }

                ultimoValorValido = auxAnyos[y].total;
            }
        }


        total = porcentajeAnyos / cantidadAnyos;

        
        /*if(total == 0)
            return ultimoValorValido*/

        if(total > 0)
        {
            total = ultimoValorValido + (total/100*ultimoValorValido)
        }
        else
        {
            total = ultimoValorValido - (total/100*ultimoValorValido)
        }

        if(isNaN(total))
            total = "";
        else
            total = Math.round(total);

        return total;

      },
      getStockProduccion(item){
        let aux = item.prevision - item.stock;
        if(aux <= 0)
            aux = "";
        return aux;
      },
      loadMore() {
        if(this.buscar == "")
        {
            this.countItemView += this.nextScrollItemView;
            this.articulosBusqueda = this.articulos.slice(0,this.countItemView);
        }
      },  
      togglePicker(data)
      {        
        this.itemSelect = data.item;
      },
      rowClick(data)
      {
        this.itemSelect = data;
        this.calcularGrafica();
        this.$bvModal.show('modal-analityc');
      },
      calcularGrafica()
      {
         let auxSeries = [];

         this.itemSelect.cantidades.forEach(item => {

          let serie = auxSeries.filter(function (el) {
            return el.name == String(item.anyo);
          });

          if(serie.length > 0)
          {
            serie[0].data[item.mes-1] = item.total;
          }
          else
          {

            let newYear = {
              name: String(item.anyo),
              data: [0,0,0,0,0,0,0,0,0,0,0,0]
            };

            //data: [null,null,null,null,null,null,null,null,null,null,null,null,null]
            //data: [0,0,0,0,0,0,0,0,0,0,0,0,0]

            newYear.data[item.mes-1] = item.total;

            auxSeries.push(newYear);
          }

         });

         /*{
              name: "2019",
              data: [10, 41, 35, 51, 49, 62, 69, 91, 148,100,100,100]
          }*/
          
        let auxChart = {
            chart: {
              height: 350,
              type: 'line',
              zoom: {
                enabled: false
              },
              toolbar: {
                show: false,
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'straight'
            },
            title: {
              text: '',
              align: 'left'
            },
            grid: {
              row: {
                colors: ['transparent', 'transparent'],
                opacity: 0.5
              },
            },
            xaxis: {
              categories: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            }
          };

          this.series = [];
          //this.chartOptions = {};
          setTimeout(()=>{
            this.series = auxSeries;
            //this.chartOptions = auxChart;
          }, 100);
      

      },
      sortChanged(e) {

        this.lastSort = e;

        /*let auxSorting = JSON.parse(JSON.stringify(this.articulos));

        if(e.sortDesc)
          auxSorting.sort((a,b) => b[e.sortBy] - a[e.sortBy]);
        else
          auxSorting.sort((a,b) => a[e.sortBy] - b[e.sortBy]);


        auxSorting = auxSorting.slice(0,this.countItemView);

        this.buscarFuncion(auxSorting);*/
        this.buscarFuncion();

      },
      buscarFuncion(items = this.articulos ){

        let auxSorting = JSON.parse(JSON.stringify(items));

        if(this.lastSort != null)
        {
          if(this.lastSort.sortDesc)
            auxSorting.sort((a,b) => b[this.lastSort.sortBy] - a[this.lastSort.sortBy]);
          else
            auxSorting.sort((a,b) => a[this.lastSort.sortBy] - b[this.lastSort.sortBy]);

          if(this.lastSort.sortBy == "title")
          {
            if(this.lastSort.sortDesc)
              auxSorting.sort((a, b) => b.title.localeCompare(a.title))
            else
              auxSorting.sort((a, b) => a.title.localeCompare(b.title))
          }
            
        }

        items = auxSorting;
        
        this.articulosBusqueda = [];

        if(this.buscar == "")
        {
          this.articulosBusqueda = items.slice(0,this.countItemView);
        }
        else
        {
          let articulosEncontrado = [];
          items.forEach(articulo => {
            if(articulo.title.toLowerCase().includes(this.buscar.toLowerCase()))
              articulosEncontrado.push(articulo);
          });

          this.articulosBusqueda = articulosEncontrado.slice(0,this.countItemView);
        }
      },
      recalcularDatos()
      {
        this.watching = false;
        this.totalNetoAnyo = 0;
        this.totalNetoVs = 0;
        this.cargarColumnas();
        this.articulos.forEach(arti => {
          this.calcularDatos(arti);
            /*this.calcularPrevisiones(arti);
            this.anyos.forEach(element => {
              this.getCantidadAnyo(arti,element.nombre)
            });*/
        });

        this.watching = true;

        this.buscarFuncion();
      },
      onRowSelected(items) {
        /*if(items.length > 0)
          this.selected = items*/
      },
      checkClick(data){
        if(data.check)
          this.selected.push(data);
        else
        {
          const index = this.selected.indexOf(data);
          if (index > -1) { 
            this.selected.splice(index, 1);
          }

        }
      },
      clearSelected() {
        this.$refs.tableproducts.clearSelected();

        this.selected.forEach(product => {
          product.check = false;          
        });
        this.selected = [];
      },
      selectTop(cantidad){
        this.$refs.tableproducts.clearSelected();
        
        this.selected.forEach(product => {
          product.check = false;
        });

        this.selected = [];

        for (let index = 0; index < cantidad; index++) {
          this.$refs.tableproducts.selectRow(index);
          this.articulosBusqueda[index].check = true;
          this.selected.push( this.articulosBusqueda[index]);
        }

      }
    },
     mounted() {    
      this.loadItems();
    },
    
    watch: {
      buscar(){
        this.buscarFuncion();
      },
      "itemSelect.pedidoAnual": function (newVal, oldVal){
        if (this.itemSelect.pedidoAnual != undefined)
        {
            axios
                .post("/articulos/sku/pedido",{sku: this.itemSelect.sku, pedidoAnual: this.itemSelect.pedidoAnual, pedidoActual: this.itemSelect.pedidoActual})
                .then(response => {
                    return response.data;
                })
                .then(res => {
                });
        }
        
      },
       "itemSelect.pedidoActual": function (newVal, oldVal){

        if (this.itemSelect.pedidoActual != undefined)
        {
            axios
                .post("/articulos/sku/pedido",{sku: this.itemSelect.sku, pedidoAnual: this.itemSelect.pedidoAnual, pedidoActual: this.itemSelect.pedidoActual})
                .then(response => {
                    return response.data;
                })
                .then(res => {        
                });
        }
        
      },
      meses: {
        handler(newValue, oldValue) {
          if(this.watching)
            this.recalcularDatos();
        },
        deep: true
      },
      anyos: {
        handler(newValue, oldValue) {
          if(this.watching)
            this.recalcularDatos();
        },
        deep: true
      },
      anyoSelect(){
        this.recalcularDatos();
      },
      anyoVS(){
        this.recalcularDatos();
      },
      mesesTodosCheck(){
        this.meses.forEach(mes => {
          mes.active = this.mesesTodosCheck;
        });
      }

    }
  }
</script>

<style lang="scss">
@import '../@core/scss/vue/libs/chart-apex.scss';
@import '../@core/scss/vue/libs/vue-select.scss';
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500;600;700&display=swap');

.cursor-pointer { cursor: pointer; }
.sku-button:hover { cursor: pointer; text-decoration: underline; }

// ══════════════════════════════════════════════════════════════
// MARKETING — same tokens as /pedido-taller-vero/fabricando
// ══════════════════════════════════════════════════════════════

$mk-bg:        #F8FAFC;
$mk-surface:   #FFFFFF;
$mk-surface-2: #F1F5F9;
$mk-border:    #E2E8F0;
$mk-divider:   #EEF2F7;
$mk-ink:       #1E293B;
$mk-text:      #1E293B;
$mk-mute:      #64748B;
$mk-soft:      #94A3B8;
$mk-primary:   #3B82F6;
$mk-cta:       #F97316;
$mk-emerald:   #10B981;
$mk-coral:     #EF4444;

.mk {
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  background: $mk-bg;
  color: $mk-text;
  margin: -2rem;
  padding: 28px 32px 56px;
  min-height: calc(100vh - 4rem);
  font-feature-settings: "tnum", "zero";

  *, *::before, *::after { box-sizing: border-box; }

  // ──────────── HEADER CARD ────────────
  .mk-dash-header {
    background: $mk-surface;
    border: 1px solid $mk-border;
    border-radius: 14px;
    padding: 18px 20px 16px;
    margin-bottom: 18px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  }

  .mk-dash-header-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    flex-wrap: wrap;
  }

  .mk-eyebrow {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    font-weight: 600;
    color: $mk-primary;
    letter-spacing: 0.14em;
    margin-bottom: 4px;

    &::before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      background: $mk-cta;
      border-radius: 50%;
      margin-right: 6px;
      vertical-align: middle;
      animation: mk-pulse 2s infinite;
    }
  }

  .mk-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 22px;
    font-weight: 700;
    color: $mk-ink;
    line-height: 1.1;
    letter-spacing: -0.01em;
    margin: 0;
  }

  .mk-header-actions {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
  }

  .mk-stat-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 38px;
    padding: 0 14px;
    background: $mk-bg;
    border: 1px solid $mk-border;
    border-radius: 8px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 12px;
    font-weight: 500;
    color: $mk-mute;

    i { color: $mk-primary; font-size: 12px; }
    strong {
      font-family: 'JetBrains Mono', monospace;
      font-size: 13px;
      font-weight: 700;
      color: $mk-ink;
      font-feature-settings: "tnum";
    }

    &--vs i { color: $mk-mute; }
    &--sel {
      background: rgba(59, 130, 246, 0.06);
      border-color: rgba(59, 130, 246, 0.2);
      i { color: $mk-primary; }
    }
  }

  // ──────────── CARD ────────────
  .mk-card {
    background: $mk-surface;
    border: 1px solid $mk-border;
    border-radius: 14px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    margin-bottom: 18px;
    overflow: hidden;
  }

  .mk-card-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 16px 20px 14px;
    border-bottom: 1px solid $mk-divider;
    flex-wrap: wrap;
  }

  .mk-card-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 18px;
    font-weight: 700;
    color: $mk-ink;
    letter-spacing: -0.015em;
    display: flex;
    align-items: center;
    gap: 8px;
    line-height: 1.2;
  }

  .mk-chevron {
    font-family: 'JetBrains Mono', monospace;
    font-size: 18px;
    font-weight: 800;
    color: $mk-primary;
    line-height: 1;
  }

  .mk-title-badge {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    font-weight: 700;
    color: $mk-primary;
    background: rgba(59, 130, 246, 0.10);
    padding: 3px 8px;
    border-radius: 6px;
    margin-left: 4px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .mk-card-actions {
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  .mk-card-body {
    padding: 18px 20px;
  }

  // ──────────── FILTERS ────────────
  .mk-filters {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
  }

  .mk-filter {
    flex: 0 0 200px;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .mk-filter-label {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    font-weight: 600;
    color: $mk-soft;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    margin: 0;
  }

  .mk-vselect {
    .vs__dropdown-toggle {
      background: $mk-surface !important;
      border: 1px solid $mk-border !important;
      border-radius: 8px !important;
      min-height: 38px;
      padding: 0 6px;
      box-shadow: none !important;
    }
    &.vs--open .vs__dropdown-toggle,
    .vs__dropdown-toggle:focus-within {
      border-color: $mk-primary !important;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12) !important;
    }
    .vs__selected, .vs__search {
      font-family: 'Plus Jakarta Sans', sans-serif;
      font-size: 13px;
      color: $mk-ink;
      padding: 0 6px;
      line-height: 36px;
    }
    .vs__open-indicator { fill: $mk-soft; transform: scale(0.75); }
    .vs__dropdown-menu {
      background: $mk-surface;
      border: 1px solid $mk-border;
      border-radius: 8px;
      box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);
      padding: 4px;
    }
    .vs__dropdown-option {
      font-family: 'Plus Jakarta Sans', sans-serif;
      font-size: 13px;
      color: $mk-text;
      padding: 8px 10px;
      border-radius: 6px;
      &--highlight { background: $mk-surface-2; color: $mk-primary; }
    }
  }

  // ──────────── MESES ────────────
  .mk-meses {
    margin-top: 18px;
    padding-top: 16px;
    border-top: 1px dashed $mk-divider;
  }

  .mk-meses-label {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 10px;

    > span {
      font-family: 'JetBrains Mono', monospace;
      font-size: 10px;
      font-weight: 600;
      color: $mk-soft;
      letter-spacing: 0.1em;
      text-transform: uppercase;
    }
  }

  .mk-meses-toggle {
    margin: 0 !important;

    .custom-control-label {
      font-size: 12px;
      color: $mk-mute;
      font-weight: 600;
    }
  }

  .mk-meses-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .mk-mes {
    height: 32px;
    padding: 0 14px;
    background: $mk-bg;
    border: 1px solid $mk-border;
    border-radius: 8px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 12px;
    font-weight: 600;
    color: $mk-mute;
    cursor: pointer;
    transition: all 150ms ease;
    text-transform: capitalize;

    &:hover {
      background: $mk-surface-2;
      color: $mk-ink;
      border-color: $mk-soft;
    }

    &.is-active {
      background: $mk-primary;
      color: #fff;
      border-color: $mk-primary;
      box-shadow: 0 2px 8px rgba(59, 130, 246, 0.25);
    }
  }

  // ──────────── QUICK BUTTONS ────────────
  .mk-quick-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 32px;
    padding: 0 12px;
    background: $mk-surface;
    border: 1px solid $mk-border;
    border-radius: 8px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 11px;
    font-weight: 600;
    color: $mk-mute;
    cursor: pointer;
    transition: all 150ms ease;

    i { font-size: 10px; }
    &:hover { background: $mk-surface-2; color: $mk-ink; border-color: $mk-soft; }
  }

  .mk-tops {
    display: inline-flex;
    background: $mk-bg;
    border: 1px solid $mk-border;
    border-radius: 8px;
    padding: 3px;
    gap: 2px;
  }

  .mk-top-btn {
    height: 26px;
    padding: 0 12px;
    background: transparent;
    border: 0;
    border-radius: 6px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 11px;
    font-weight: 600;
    color: $mk-mute;
    cursor: pointer;
    transition: all 150ms ease;

    &:hover {
      background: $mk-surface;
      color: $mk-primary;
      box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
    }
  }

  // ──────────── SEARCH BAR ────────────
  .mk-search-bar {
    position: relative;
    padding: 14px 20px;
    border-bottom: 1px solid $mk-divider;
    background: $mk-surface;

    i:first-child {
      position: absolute;
      left: 32px;
      top: 50%;
      transform: translateY(-50%);
      color: $mk-soft;
      font-size: 12px;
      pointer-events: none;
    }

    input {
      width: 100%;
      height: 38px;
      padding: 0 36px 0 36px;
      background: $mk-bg;
      border: 1px solid $mk-border;
      border-radius: 8px;
      font-family: 'Plus Jakarta Sans', sans-serif;
      font-size: 13px;
      color: $mk-ink;
      transition: all 150ms ease;

      &::placeholder { color: $mk-soft; }
      &:focus {
        outline: none;
        border-color: $mk-primary;
        background: $mk-surface;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
      }
    }

    .mk-search-clear {
      position: absolute;
      right: 28px;
      top: 50%;
      transform: translateY(-50%);
      width: 22px;
      height: 22px;
      border: 0;
      background: $mk-divider;
      color: $mk-mute;
      border-radius: 50%;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 10px;
      &:hover { background: $mk-coral; color: #fff; }
    }
  }

  // ──────────── B-TABLE OVERRIDES ────────────
  .table {
    background: $mk-surface !important;
    margin-bottom: 0 !important;
    font-family: 'Plus Jakarta Sans', sans-serif;

    thead th {
      font-family: 'JetBrains Mono', monospace !important;
      font-size: 10px !important;
      font-weight: 600 !important;
      color: $mk-soft !important;
      letter-spacing: 0.08em !important;
      text-transform: uppercase;
      background: $mk-surface !important;
      border-bottom: 1px solid $mk-border !important;
      border-top: 0 !important;
      padding: 12px 14px !important;
    }

    tbody tr {
      transition: background 150ms ease;
      background: $mk-surface !important;

      td {
        border-top: 1px solid $mk-divider !important;
        font-size: 12.5px;
        color: $mk-text !important;
        padding: 10px 14px !important;
        vertical-align: middle;
        background: transparent !important;
      }
      &:hover { background: rgba(59, 130, 246, 0.04) !important; }
    }
  }

  .tabla-marketing {
    th {
      font-size: 10px !important;
      letter-spacing: 0.08em !important;
    }
    thead tr {
      position: sticky;
      top: 0;
      z-index: 5;
    }
  }

  .table-details {
    margin-top: -1px;
    background: $mk-surface-2 !important;
    th, td { background: $mk-surface-2 !important; }
  }

  .b-table-details td:first-child { padding: 0 !important; }
  .hidden_header { visibility: hidden; }

  // SKU button
  .sku-button {
    color: $mk-primary;
    font-family: 'JetBrains Mono', monospace;
    font-size: 11.5px;
    font-weight: 600;
    cursor: pointer;
    &:hover { text-decoration: underline; color: darken($mk-primary, 8%); }
  }

  // checkbox in table
  .custom-checkbox .custom-control-label::before {
    border-color: $mk-border;
    border-radius: 4px;
  }
  .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
    background: $mk-primary !important;
    border-color: $mk-primary !important;
  }

  // form switch
  .custom-switch .custom-control-label::before {
    background: $mk-border !important;
    border-color: $mk-border !important;
  }
  .custom-switch .custom-control-input:checked ~ .custom-control-label::before {
    background: $mk-primary !important;
    border-color: $mk-primary !important;
  }

  @keyframes mk-pulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.55; transform: scale(0.85); }
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      transition-duration: 0.01ms !important;
    }
  }
}

// ══════════ DARK MODE ══════════
.dark-layout .mk {
  background: #161616;
  color: #d0d2d6;

  .mk-dash-header,
  .mk-card { background: #1f1f1f; border-color: #2c2c2c; box-shadow: none; }
  .mk-title, .mk-card-title { color: #e4e6eb; }
  .mk-card-head { border-bottom-color: #2c2c2c; }

  .mk-stat-pill { background: #161616; border-color: #2c2c2c; }
  .mk-stat-pill strong { color: #e4e6eb; }

  .mk-vselect .vs__dropdown-toggle { background: #1f1f1f !important; border-color: #2c2c2c !important; }
  .mk-vselect .vs__selected, .mk-vselect .vs__search { color: #d0d2d6; }
  .mk-vselect .vs__dropdown-menu { background: #242424; border-color: #3a3a3a; }
  .mk-vselect .vs__dropdown-option { color: #d0d2d6; }
  .mk-vselect .vs__dropdown-option--highlight { background: #2c2c2c; color: #fff; }

  .mk-meses { border-top-color: #2c2c2c; }
  .mk-mes { background: #161616; border-color: #2c2c2c; color: #8e9099; }
  .mk-mes:hover { background: #242424; color: #e4e6eb; }
  .mk-mes.is-active { background: $mk-primary; color: #fff; }

  .mk-quick-btn { background: #1f1f1f; border-color: #2c2c2c; color: #8e9099; }
  .mk-tops { background: #161616; border-color: #2c2c2c; }
  .mk-top-btn:hover { background: #242424; color: $mk-primary; }

  .mk-search-bar { background: #1f1f1f; border-bottom-color: #2c2c2c; }
  .mk-search-bar input { background: #161616; border-color: #2c2c2c; color: #d0d2d6; &:focus { background: #242424; } }

  .table { background: #1f1f1f !important; }
  .table thead th { background: #1f1f1f !important; color: #6e7079 !important; border-bottom-color: #2c2c2c !important; }
  .table tbody tr td { border-top-color: #2c2c2c !important; color: #d0d2d6 !important; }
  .table tbody tr:hover { background: rgba(59, 130, 246, 0.08) !important; }
  .table-details { background: #161616 !important; th, td { background: #161616 !important; } }
}

table#table-products .flip-list-move {
  transition: transform 1s;
}

.b-table-details td:first-child {
  padding: 0px;
}

.hidden_header {
  visibility: hidden;
}

.table-details {
  margin-top: -35px;
}
</style>